import { Navigate, useParams } from 'react-router-dom';

/** Preserves `/:lang` prefix when present (mirrors dual route trees in global router). */
export default function SubscriptionsIndexRedirect() {
    const { lang } = useParams<{ lang?: string }>();
    const to =
        lang === 'ar' || lang === 'en'
            ? `/${lang}/subscriptions/packages`
            : '/subscriptions/packages';
    return <Navigate to={to} replace />;
}
